module.exports = __webpack_public_path__ + "img/r-99.efb52ddc.jpg";